import { fetchData } from '../../services/apiClient';
import { CategoryInternalData, CategoryNielsenData } from '../../pages/ScenarioCreation/components/SKUTable/types';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export const fetchPerformanceTableData = async (payload: any, type: any): Promise<any[]> => {
  const response =
    type === 'NIELSEN'
      ? await fetchData(API_ENDPOINTS.SCENARIO_INPUT.NIELSEN_PERFORMANCE_TABLE_DATA, payload)
      : await fetchData(API_ENDPOINTS.SCENARIO_INPUT.REVENUE_PERFORMANCE_TABLE_DATA, payload);
  return type === 'NEILSEN' ? (response as CategoryNielsenData[]) : (response as CategoryInternalData[]);
};
